module.exports = __webpack_public_path__ + "img/12-s.2c0e02fc.png";